import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  q: 'Cât durează programul?',
  a: 'Programul durează 7 luni. Un modul pe lună, câte un weekend. Sâmbătă de la 10:00 la 18:00 și duminică de la 09:00 la 13:00. Primul modul începe pe 9-10 mai 2026.'
}, {
  q: 'Este un curs teoretic sau practic?',
  a: 'Este în primul rând practic. Fiecare modul are exerciții aplicate, studii de caz și integrare în viața reală. În plus, ai 6 sesiuni online între module pentru să exersezi și să pui întrebări. Nu pleci cu noțiuni, pleci cu instrumente.'
}, {
  q: 'Primesc certificare la final?',
  a: 'Da. La finalul programului primești certificat NLP la nivel național și internațional. Certificarea este recunoscută și valoroasă atât pentru dezvoltare personală, cât și profesională.'
}, {
  q: 'Dacă nu înțeleg ceva din prima, am suport?',
  a: 'Da. Ai 6 sesiuni online între module, 7 meditații audio pentru integrare și, dacă simți că ai nevoie să mai parcurgi o dată materialul, poți reparticipa gratuit la următoarea ediție a cursului, ca observator.'
}, {
  q: 'Este potrivit și dacă nu am cunoștințe anterioare despre NLP?',
  a: 'Da. Programul este construit de la zero, pas cu pas. Nu ai nevoie de cunoștințe anterioare. Tot ce ai nevoie este deschidere să lucrezi cu tine însuți și disponibilitate să participi la fiecare modul.'
}, {
  q: 'Care este investiția și cum pot plăti?',
  a: 'Poți plăti 739 RON la începutul fiecărui modul, în total 5.173 RON. Sau poți plăti integral 4.461 RON și economisești 712 RON, plus primești bonusuri de 2.050 RON. Locurile sunt limitate.'
}, {
  q: 'Care este diferența față de alte cursuri de NLP?',
  a: 'Programul combină tehnici NLP cu comunicare nonverbală și profilare comportamentală, adăugând o dimensiune practică pe care multe cursuri o omit. Lucrezi direct cu situații din viața ta, nu cu exemple generice. Și ai suport între module, nu doar în weekend-urile de curs.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 bg-navy relative" data-id="element-32">
      <div className="container mx-auto px-6" data-id="element-33">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-34">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-35">
            Întrebări frecvente
          </h2>
          <div className="w-24 h-px bg-gold mx-auto" data-id="element-36" />
        </motion.div>
        <div className="max-w-3xl mx-auto space-y-4" data-id="element-37">
          {faqs.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="border-b border-gold/20" data-id="element-38">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between py-6 text-left focus:outline-none group" data-id="element-39">
                <h3 className="font-serif text-xl md:text-2xl font-bold text-white group-hover:text-gold transition-colors duration-300 pr-8" data-id="element-40">
                  {faq.q}
                </h3>
                <div className="w-8 h-8 rounded-full border border-gold/30 flex items-center justify-center shrink-0 group-hover:border-gold/60 transition-colors duration-300" data-id="element-41">
                  {openIndex === idx ? <Minus className="w-4 h-4 text-gold" data-id="element-42" /> : <Plus className="w-4 h-4 text-gold" data-id="element-43" />}
                </div>
              </button>
              <AnimatePresence data-id="element-44">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-45">
                    <div className="pb-6 pr-12" data-id="element-46">
                      <p className="font-sans text-white text-xl leading-relaxed" data-id="element-47">
                        {faq.a}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
};